import styled from 'styled-components'

import { fromMd, untilMd } from '@syconium/little-miss-figgy'

export const Layout = styled.div`
  display: flex;
`

export const SkeletonLayout = styled(Layout)``

export const Content = styled.div`
  flex: 1;
  min-width: 256px;

  ${fromMd} {
    margin: 0 auto;
    max-width: 350px;
  }
`

export const List = styled.div`
  border-top: 1px solid rgba(0, 0, 0, 0.1);

  margin-bottom: 20px;

  ${fromMd} {
    margin-bottom: 0;
  }
`

export const ShippingMessage = styled.div`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1px;
  line-height: 1.45;
  text-align: center;
  text-transform: uppercase;
  padding: 0 0 1rem;
`

export const AccordionViewSectionWrapper = styled.div`
  ${untilMd} {
    padding: 0 16px;
  }
`
